import React, { lazy, Suspense } from '../../../../../_snowpack/pkg/react.js'; // @ts-ignore

import Loading from '../../../../modules/loading/index.js';
const CrystalForm = /*#__PURE__*/lazy(() => import("./crystal-form.js"));
export default function ContactUs() {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loading, null)
  }, /*#__PURE__*/React.createElement(CrystalForm, null));
}